import type {
  DashboardApprovalDocumentItem,
  DashboardCard,
  DashboardCardKey,
  DashboardResponse,
  DashboardTaskItem,
  DashboardUnresolvedCommentDocument,
} from "@models";

const TASK_SUPPORT_CARD_KEYS = new Set<DashboardCardKey>([
  "open-tasks",
  "outdated-due-soon",
]);

const DOCUMENT_SUPPORT_CARD_KEYS = new Set<DashboardCardKey>([
  "documents-currently-routing",
]);

const hasSupportedCard = (
  dashboard: DashboardResponse | undefined,
  cardKeys: Set<DashboardCardKey>
) => dashboard?.cards.some((card) => cardKeys.has(card.key)) ?? false;

export const dashboardNeedsTaskSupport = (
  dashboard: DashboardResponse | undefined
) => hasSupportedCard(dashboard, TASK_SUPPORT_CARD_KEYS);

export const dashboardNeedsDocumentSupport = (
  dashboard: DashboardResponse | undefined
) => hasSupportedCard(dashboard, DOCUMENT_SUPPORT_CARD_KEYS);

export const getDashboardTaskItems = (
  card: DashboardCard | undefined
): DashboardTaskItem[] =>
  (card?.items ?? []).filter(
    (item): item is DashboardTaskItem => item.type === "task"
  );

export const getDashboardApprovalDocumentItems = (
  card: DashboardCard | undefined
): DashboardApprovalDocumentItem[] =>
  (card?.items ?? []).filter(
    (item): item is DashboardApprovalDocumentItem =>
      item.type === "approval-document"
  );

export const getDashboardUnresolvedCommentItems = (
  card: DashboardCard | undefined
): DashboardUnresolvedCommentDocument[] =>
  (card?.items ?? []).filter(
    (item): item is DashboardUnresolvedCommentDocument =>
      item.type === "unresolved-comment-document"
  );
